
import Button from '../base/Button';

export default function Hero() {
  return (
    <section className="relative bg-gradient-to-br from-blue-50 to-white py-20 overflow-hidden"
      style={{
        backgroundImage: `url('https://public.readdy.ai/ai/img_res/88595d5e3f9383fc1c7c1306ed1e7b57.jpg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center right'
      }}>
      <div className="absolute inset-0 bg-white/80"></div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="w-full">
          <div className="max-w-3xl">
            <div className="bg-green-100 text-green-800 px-4 py-2 rounded-full text-sm font-medium inline-block mb-6">
              🎉 Beta Launch - Save 50% Limited Time!
            </div>
            
            <h1 className="text-5xl md:text-6xl font-bold text-gray-900 leading-tight mb-6">
              Automate Your Invoice Processing in 
              <span className="text-blue-600"> Minutes</span>
            </h1>
            
            <p className="text-xl text-gray-600 mb-8 leading-relaxed max-w-2xl">
              Stop wasting hours on manual invoice entry. Ledger Linc automatically captures, processes, and posts invoices to QuickBooks and MSBC - saving you time, money, and eliminating errors.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 mb-8">
              <Button size="lg" className="text-lg px-10">
                <i className="ri-play-circle-line mr-2 text-xl"></i>
                Start Free Trial
              </Button>
              <Button variant="secondary" size="lg" className="text-lg px-8">
                <i className="ri-discount-percent-line mr-2 text-xl"></i>
                Join Beta & Save 50%
              </Button>
              <Button variant="outline" size="lg" className="text-lg px-8">
                <i className="ri-calendar-line mr-2 text-xl"></i>
                Book a Demo
              </Button>
            </div>
            
            <div className="flex items-center space-x-6 text-sm text-gray-500">
              <div className="flex items-center">
                <i className="ri-check-circle-fill text-green-500 mr-2"></i>
                No setup fees
              </div>
              <div className="flex items-center">
                <i className="ri-check-circle-fill text-green-500 mr-2"></i>
                Cancel anytime
              </div>
              <div className="flex items-center">
                <i className="ri-check-circle-fill text-green-500 mr-2"></i>
                14-day free trial
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
